module.exports = __webpack_public_path__ + "static/media/404.fa7dee45.svg";